import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const InsightWidgetRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const DisclaimerWrapper = styled.div`
  ${typographyV2.bodyXs};
  color: var(--text-soft);
`;

export const DisclaimerButton = styled.button`
  display: flex;
  gap: 4px;
  align-items: center;
  padding: 0;
  background-color: transparent;
  border: transparent;
  width: fit-content;
  color: var(--text-soft);
  cursor: pointer;
  &:hover {
    color: var(--text-default);
  }
`;
export const SplitContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
